import { Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { palette } from "../../../styles/theme";
import { useSelector } from "../../../common/hooks/useSelector";
import { useTranslation } from "react-i18next";
import { useCurrency } from "../../../common/hooks/useCurrency";
import config from "../../../config";
import { ComboItems, ItemPricing } from "../../../types";
import { CalculatePriceModal } from "../../../components/CalculatePriceModal";
import { Box } from "../../../common/components";
import { useThemeBreakpoints } from "../../../utils/themeUtils";

interface Props {
  comboItems: ComboItems;
  item: ItemPricing;
}

const CartItemPrice = ({ comboItems, item }: Props) => {
  const { t } = useTranslation();
  const [isPriceModalOpen, setIsPriceModalOpen] = useState(false);
  const { showDistributorPrices } = useSelector((state) => state.cart);
  const { isMobile } = useThemeBreakpoints();
  const { aboveMinimumQuantity, belowMaximumQuantity, quantity } = comboItems;
  const {
    deprecatedDesign: deprecatedDesignFromCartItem,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    minimumQuantityPerSizeReached,
    productName,
    designId,
    distributor,
  } = item;
  const { NarrowCurrencyFormatter } = useCurrency();

  const deprecatedDesign = useMemo(() => {
    return (
      (deprecatedDesignFromCartItem &&
        config.blockPaymentWhenDesignIsDeprecated) ||
      false
    );
  }, [deprecatedDesignFromCartItem]);

  const pricePerUnit =
    showDistributorPrices && !!distributor
      ? distributor.pricePerUnit
      : item.pricePerUnit;

  return (
    <>
      {isMobile ? (
        !deprecatedDesign &&
        aboveMinimumQuantity &&
        belowMaximumQuantity && (
          <Box display={"flex"} alignItems={"center"}>
            <Typography
              variant="textSm"
              color={palette.grey.primary}
            >{`${quantity} x`}</Typography>
            <Typography
              variant="textSm"
              color={palette.blue.secondary}
              sx={{ cursor: "pointer" }}
              onClick={() => setIsPriceModalOpen(true)}
            >
              &nbsp;
              {`${NarrowCurrencyFormatter?.format(
                showDistributorPrices && !!distributor
                  ? distributor.pricePerUnit
                  : item.pricePerUnit
              )}`}
            </Typography>
          </Box>
        )
      ) : (
        <Typography
          variant="textRegular"
          color={palette.blue.secondary}
          display="block"
          minHeight={{ xs: undefined, lg: 17 }}
          width={"fit-content"}
          onClick={() => setIsPriceModalOpen(true)}
          sx={{
            cursor: "pointer",
            ":hover": {
              textDecoration: "underline",
            },
          }}
        >
          {!deprecatedDesign &&
            (!belowMaximumQuantity
              ? t("checkout.goingbig")
              : NarrowCurrencyFormatter?.format(pricePerUnit))}
        </Typography>
      )}
      <CalculatePriceModal
        open={isPriceModalOpen}
        onClose={() => setIsPriceModalOpen(false)}
        designId={designId}
        productName={productName}
        defaultQuantity={comboItems.quantity}
      />
    </>
  );
};

export default CartItemPrice;
